import { MigrateOffersRequest, Offer, OfferCreate, OfferUpdate } from "../models/offers";
import api from "./index";

const BASE = '/offers';

export const getAllOffers = async (params = {}) => {
    try {
        const response = await api.get(`${BASE}/getall`, { params });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch offers:', error);
        throw error;
    }
};


export const createOffer = async (offer: OfferCreate): Promise<Offer> => {
    try {
        const response = await api.post(`${BASE}/create`, offer);
        return response.data as Offer;
    } catch (error) {
        console.error("Failed to create offer:", error);
        throw error;
    }
};

export const getMyOffers = async (params = {}) => {
    try {
        const response = await api.get(`${BASE}/myoffers`, { params });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch offers:', error);
        throw error;
    }
};


export const getOfferByID = async (offer_id: number) => {
    try {
        const response = await api.get(`${BASE}/${offer_id}`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch offer:', error);
        throw error;
    }
};


export const updateOfferByID = async (updates: OfferUpdate): Promise<Offer> => {
    try {
        const response = await api.patch(`${BASE}/update`, updates);
        return response.data as Offer;
    } catch (error) {
        console.error("Failed to update offer:", error);
        throw error;
    }
};

export const getVerticals = async () => {
    try {
        const response = await api.get(`${BASE}/getverticals`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch verticals:', error);
        throw error;
    }
};

export const getStates = async () => {
    try {
        const response = await api.get(`${BASE}/getstates`);
        return response.data;
    } catch (error) {
        console.error('Failed to fetch states:', error);
        throw error;
    }
};


export const getSupply = async (params = {}) => {
    try {
        const response = await api.get(`${BASE}/getsupply`, { params });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch supply:', error);
        throw error;
    }
};

export const getMySupply = async (params = {}) => {
    try {
        const response = await api.get(`${BASE}/getmysupply`, { params });
        return response.data;
    } catch (error) {
        console.error('Failed to fetch user supply:', error);
        throw error;
    }
};


export const isOfferOwner = async (offer_id: number): Promise<boolean> => {
    try {
        const response = await api.get(`${BASE}/${offer_id}/is_owner`);
        return response.data;
    } catch (error) {
        console.error("Failed to verify offer ownership:", error);
        throw error;
    }
};

export const getUserOffers = async (email: string): Promise<Offer[]> => {
    try {
        const response = await api.get(`${BASE}/user_offers`, { params: { email } });
        return response.data as Offer[];
    } catch (error) {
        console.error(`Failed to fetch offers for ${email}:`, error);
        throw error;
    }
};

export const deleteOffer = async (offer_id: number) => {
    try {
        const response = await api.delete(`${BASE}/delete/${offer_id}`);
        return response.data;
    } catch (error) {
        console.error('Failed to delete offer:', error);
        throw error;
    }
};

export const migrateAllOffers = async (emails: MigrateOffersRequest) => {
    try {
        const response = await api.post(`${BASE}/migrateall`, emails);
        return response.data as Offer[];
    } catch (error) {
        console.error("Failed to update offer:", error);
        throw error;
    }
}